import mapImage from '../assets/misc/map.png'; // Adjust the path as necessary

import "../styles/contact.css"
const Contact = () => {
  return (
      <div className="contact-page">
          <div className="contact-left-section">
              <h2>Contact Us</h2>
              <p>We'd love to hear from you! Whether you have questions about our services, need assistance with a specific project, or are interested in custom solutions tailored to your needs, feel free to reach out using the form below.</p>
              <p>At FramSys, we're dedicated to providing top-notch support and innovative solutions. Your satisfaction is our priority, so please don't hesitate to get in touch. We look forward to connecting with you!</p>
              <p>You can reach us at: <strong>sales@framsys.net</strong></p>
          </div>
          <div className="contact-right-section">
              <h2>Find Us</h2>
              <p>Visit us at our office located in:</p>
              <p><strong>22150 Jomala, Blomstringevägen 12 - Åland</strong></p>
              <MapSection />
          </div>
      </div>
  );
};


const MapSection = () => {
  return (
    <div>

    
    <div className="contact-map-container">
      <img src={mapImage} alt="FramSys Office Location" />
    </div>

     </div>
  );
};

export default Contact;
